<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tPTZtO/tc-custom/9783987448959.jpg?1704424984064" alt="This image is the cover for the book Marriage and Love, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Marriage and Love, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>In Emma Goldman's essay Marriage and Love (1914) she believes that marriage and love are all part of this superstition that people uphold in order to have meaning in society. Goldman wants people to know that marriage and love shouldn't be seen as a correlation. You don't need one to have the other.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Emma Goldman
      </h2>
      
      <p class="authorDescription body article">Emma Goldman (June 27, 1869 – May 14, 1940) was an anarchist political activist and writer. She played a pivotal role in the development of anarchist political philosophy in North America and Europe in the first half of the 20th century.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fe4c1890